// extracted by mini-css-extract-plugin
module.exports = {"note":"style_note__2ES2jV703p93lGcOBarWR9"};